import React, { useState, useEffect, useRef } from 'react';
import './UserForm.css';
import Joyride from 'react-joyride';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss'
import '@sweetalert2/theme-material-ui/material-ui.css';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import { Info_8 } from '../utils/toastMessages';
import translations from '../utils/translations.json';
import fontList /*, fontListStories*/ from '../utils/fontList';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdMenu, MdAddCircle, MdLink, MdCameraAlt, MdDashboard, MdAutorenew, MdEventAvailable, MdFace, MdForum, MdSettings, MdLocalActivity, MdKeyboardArrowLeft, MdArrowBack } from "react-icons/md";
import { RiCopperCoinLine } from "react-icons/ri";
import { FaInstagram, FaRobot } from 'react-icons/fa';
import CustomDrawer from './CustomDrawer';
import createCache from '@emotion/cache';
import { SketchPicker } from 'react-color';
import { Modal, ModalOverlay, ModalContent, useMediaQuery, ModalFooter, ModalBody, Button, ChakraProvider } from "@chakra-ui/react";

const UserForm = ({ mode = 'add' }) => {
    const [name, setName] = useState("");
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'pt');
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [cellPhoneNumber, setCellPhoneNumber] = useState("");
    const [temporaryPassword, setTemporaryPassword] = useState("");
    // const { userId } = useParams();
    const userId = localStorage.getItem('userId');
    const navigate = useNavigate();
    const location = useLocation();

    // Detectar se veio do GrowthPilot
    const params = new URLSearchParams(location.search);
    const fromGrowthPilot = params.get('from') === 'growthpilot';

    const [isCanAddUsers, setCanAddUsers] = useState(null);
    const [avatarUrl, setAvatarUrl] = useState(`${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`);
    const [perfilName, setPerfilName] = useState("");
    const [perfilLastName, setPerfilLastName] = useState("");
    const [writingStyle, setWritingStyle] = useState("");
    const [isMobileII] = useMediaQuery('(max-width: 768px)');
    const [isGPT4Enabled, setIsGPT4Enabled] = useState(() => {
        const saved = localStorage.getItem('isGPT4Enabled');
        return saved === 'true'; // Retorna true se o valor armazenado for a string 'true'
    });

    const [isOpen, setIsOpen] = useState(false);
    const [isLoadingInitial, setIsLoadingInitial] = useState(true);
    const [totens, setTotens] = useState([]);
    const [activeTotenIndex, setActiveTotenIndex] = useState(0);
    const [totenIndex, setTotenIndex] = useState(0);

    const [shouldSaveTotens, setShouldSaveTotens] = useState(false);
   /* const [colorTotenIndex, setColorTotenIndex] = useState(null);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [colorType, setColorType] = useState('');
    const [colors, setColors] = useState({
        Titulos: '#ffffff',
        Textos: '#ffffff',
        Fundo: '#ffffff'
    }); */

    const [accessToken, setAccessToken] = useState(null);
    const [selectedPage, setSelectedPage] = useState(null);
    const [instagramAccountId, setInstagramAccountId] = useState(null);
    const [totenConnections, setTotenConnections] = useState(() => totens.map(() => false));
    const typeofPlan = localStorage.getItem('typeofPlan');

    const isFirstRun = useRef(true);
    let firstAccess = false;

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobile] = useMediaQuery('(max-width: 768px)');

    useEffect(() => {

        if (totens.length > 0) {
            const now = new Date();

            if (localStorage.getItem('firstAccess') !== 'undefined' && localStorage.getItem('firstAccess') === 'true') {

                firstAccess = true;


            }

            setTotenConnections(totens.map(toten => {

                if (isFirstRun.current && firstAccess) {

                    Swal.fire({
                        title: t('profile', 'firstTimeTitle'),
                        text: t('profile', 'firstTimeText'),
                        icon: 'info',
                        confirmButtonText: t('profile', 'confirmButtonBusiness'),
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setRunJoyride(true);
                        }
                    });

                    isFirstRun.current = false;
                }

                return new Date(toten.tokenExpiry) > now;

            }));
        }
    }, [totens]);



    const t = (screen, key) => translations[language][screen][key];
    const [hasLoadedInitialData, setHasLoadedInitialData] = useState(false);


    const [runJoyride, setRunJoyride] = useState(false);
    const [joyrideSteps, setJoyrideSteps] = useState([
        {
            target: '.avatar-container',
            content: t('profile', 'joyrideSteps')[0].content,
        },
        {
            target: '.firstName',
            content: t('profile', 'joyrideSteps')[1].content,
        },
        {
            target: '.lastName',
            content: t('profile', 'joyrideSteps')[2].content,
        },
        {
            target: '.social',
            content: t('profile', 'joyrideSteps')[3].content,
        },
        {
            target: '.textAreaFundo',
            content: t('profile', 'joyrideSteps')[4].content,
        },
        {
            target: '.scrollable-container',
            content: t('profile', 'joyrideSteps')[5].content,
        },
        {
            target: '.saveBtn',
            content: t('profile', 'joyrideSteps')[6].content,
        },
        {
            target: '.activeBtn',
            content: t('profile', 'joyrideSteps')[7].content,
        },
        {
            target: '.add-toten-button-container',
            content: t('profile', 'joyrideSteps')[8].content,
        },
    ]);

    const [isLoading, setIsLoading] = useState(false);

    const isViewMode = mode === 'view';

    const [selectedColor, setSelectedColor] = useState('#ffffff'); // Estado para a cor selecionada temporariamente

 /*   const openColorPicker = (index, type) => {
        // setActiveTotenIndex(index); // Defina o índice do totem ativo
        setColorTotenIndex(index);
        setColorType(type);
        setSelectedColor(totens[index].colors[type]); // Acesse a cor atual do totem
        setShowColorPicker(true);
    };

    // Atualiza a cor selecionada temporariamente sem fechar o modal
    const handleColorChange = (color) => {
        setSelectedColor(color.hex);
    };

    // Aplica a cor selecionada e fecha o modal
    const handleConfirmColor = () => {

        const updatedTotens = totens.map((toten, idx) =>
            idx === colorTotenIndex ? { ...toten, colors: { ...toten.colors, [colorType]: selectedColor } } : toten
        );
        setTotens(updatedTotens);
        setShowColorPicker(false);
    }; */

    const [totenConfigs, setTotenConfigs] = useState([]);


   /* const handleTitleFontChange = (index, font) => {
        const newConfigs = [...totenConfigs];
        if (newConfigs[index].titleFont !== font) {
            newConfigs[index].titleFont = font;
            //  newConfigs[index].titleFontChanged = true; // Adiciona um indicativo de que houve mudança intencional
        }
        setTotenConfigs(newConfigs);
    };

    const handleTextFontChange = (index, font) => {
        const newConfigs = [...totenConfigs];
        if (newConfigs[index].textFont !== font) {
            newConfigs[index].textFont = font;
            //  newConfigs[index].textFontChanged = true; // Adiciona um indicativo de que houve mudança intencional
        }
        setTotenConfigs(newConfigs);
    }; */


  /*  useEffect(() => {
        const head = document.getElementsByTagName('head')[0];

        // Remove todos os links anteriores para evitar duplicações
        const existingLinks = document.querySelectorAll('link[id^="google-fonts-"]');
        existingLinks.forEach(link => head.removeChild(link));

        // Carrega novas fontes de título e texto
        totenConfigs.forEach((config, index) => {
            // Para a fonte do título
            let linkTitle = document.createElement('link');
            linkTitle.id = `google-fonts-title-${index}`;
            linkTitle.rel = 'stylesheet';
            linkTitle.href = `https://fonts.googleapis.com/css2?family=${config.titleFont.replace(/ /g, '+')}&display=swap`;
            head.appendChild(linkTitle);

            // Para a fonte do texto
            let linkText = document.createElement('link');
            linkText.id = `google-fonts-text-${index}`;
            linkText.rel = 'stylesheet';
            linkText.href = `https://fonts.googleapis.com/css2?family=${config.textFont.replace(/ /g, '+')}&display=swap`;
            head.appendChild(linkText);
        });
    }, [totenConfigs]); */

    const emotionCache = createCache({
        key: 'emotion-cache',
        prepend: true, // Assegura que os estilos sejam inseridos no início do <head>
    });

    const handleChange = (event) => {
        const isGPT4Enabled = event.target.checked;
        setIsGPT4Enabled(isGPT4Enabled);
        localStorage.setItem('isGPT4Enabled', isGPT4Enabled.toString());
    };


    const handleHamburguerClick = () => {

        if (isViewMode) {
            setIsOpen(true); // Abre o Drawer
        } else {
            Swal.fire({
                title: t('profile', 'attention'),
                text: t('profile', 'completeRegistrationToAccess'),
                icon: 'warning',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };

    const handleCloseDrawer = () => {
        setIsOpen(false); // Fecha o Drawer
    };


    const analysisOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/growthpilot?lang=${language}`);
        } else {
        navigate(`/analysis?lang=${language}`);
        }
    }

    const historyOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/growthpilot?lang=${language}`);
        } else {
        navigate(`/history?lang=${language}`);
        }
    }

    const automacaoOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/automacao?lang=${language}&from=growthpilot`);
        } else {
        navigate(`/automacao?lang=${language}`);
        }
    }

    const logout = (language) => {
        navigate(`/login?lang=${language}`);
    }

    const mainOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/growthpilot?lang=${language}`);
        } else {
        navigate(`/main?lang=${language}`);
        }
    }

    const pciOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/pci?from=growthpilot&lang=${language}`);
        } else {
        navigate(`/pci?lang=${language}`);
        }
    }

    const [uploadPicture, setUploadPicture] = useState(false);

    useEffect(() => {
        // Função para atualizar o estado se o `localStorage` for alterado
        const handleStorageChange = () => {
            const newLanguage = localStorage.getItem('language');
            if (newLanguage !== language) {
                setLanguage(newLanguage);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [language]);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!isViewMode) {
            // Create new user
            const newUser = {
                name: name,
                lastName: lastName,
                email: email,
                cellPhoneNumber: cellPhoneNumber,
                password: temporaryPassword,
                language: language

                // ... other fields...
            }

            axios.post(process.env.REACT_APP_API_BASE_URL + '/users/register', newUser)
                .then(response => {
                    Swal.fire({
                        title: t('profile', 'successTitle'),
                        text: t('profile', 'userRegistered'),
                        icon: 'success',
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    }).then((result) => {
                        // Verifica se o botão de confirmação foi clicado no SweetAlert
                        //  if (result.isConfirmed && isNotProductionEnvironment()) {
                        // Redireciona para o login se estiver fora do ambiente de produção
                        window.location.href = `/login?lang=${language}`;

                    });
                })
                .catch(error => {
                    console.log(error);
                    Swal.fire({
                        title: t('profile', 'errorTitle'),
                        text: t('profile', 'registrationError'),
                        icon: 'error',
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    });
                });
        }
    }



    async function uploadImage(index) {

        const { value: file } = await Swal.fire({
            title: t('profile', 'chooseProfilePicture'),
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            },
            input: 'file',
            inputAttributes: {
                'accept': 'image/*',
                'aria-label': 'Upload your profile picture',
                'max-size': 5000000
            },
            customClass: {
                popup: 'my-swal-special',
                title: 'myCustomTitle'
            }
        });

        if (!file) return;

        const reader = new FileReader();

        reader.onload = async (e) => {

            const formData = new FormData();
            formData.append('image', file);

            try {

                const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/users/perfil-image', {
                    method: 'POST',
                    body: formData
                });

                // Verifique se a resposta da API está ok
                if (!response.ok) {
                    const responseData = await response.json();
                    throw new Error(responseData.error || 'Erro ao fazer upload da imagem.');
                    // Aqui, lançamos um erro se a resposta não for bem-sucedida, e isso levará ao bloco catch
                }

                const data = await response.json();

                if (data.url) {

                    const updatedTotens = totens.map((toten, idx) => {
                        if (idx === index) {

                            return { ...toten, profilePicture: data.url };
                        }
                        return toten;
                    });

                    setTotens(updatedTotens);

                    setUploadPicture(true);

                    setTotenIndex(index);
                }

            } catch (error) {
                //console.error("Erro ao fazer upload da imagem:", error);
                Swal.fire({
                    title: t('profile', 'errorTitle'),
                    text: error.response?.data?.error || t('profile', 'uploadError'),
                    icon: 'error',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }

                })
            }
        };

        reader.readAsDataURL(file);
    }

    useEffect(() => {
        // Verifique se a foto do perfil ativo foi atualizada
        if (totenIndex != null && uploadPicture) {

            const currentToten = totens[totenIndex];

            if (currentToten.perfilName.trim() && currentToten.perfilLastName.trim()) {
                saveToten(totenIndex);
            } else {
                toast.info(
                    t('profile', 'imageLoading'), {
                    type: toast.TYPE.SUCCESS,
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 2000 // Defina um tempo para o toast se fechar automaticamente após alguns segundos
                });
            }

            setUploadPicture(false);
        }
    }, [totens, totenIndex, uploadPicture]);


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/profiles/${userId}`)
            .then(profileResponse => {
                const profileData = profileResponse.data;
                if (profileData && profileData.length > 0 && profileData[0].totens && profileData[0].totens.length > 0) {
                    const loadedTotens = profileData[0].totens.map(toten => ({
                        ...toten,
                        colors: toten.colors || { Titulos: '#ffffff', Textos: '#ffffff', Fundo: '#ffffff' },
                        description: toten.description || ''
                    }));

                    setTotens(loadedTotens);

                    setTotenConfigs(loadedTotens.map(t => ({
                        titleFont: t.titleFont || '',  // Use o valor padrão se não houver configuração salva
                        textFont: t.textFont || ''
                    })));

                    const now = new Date();
                    setTotenConnections(loadedTotens.map(toten => new Date(toten.tokenExpiry) > now));

                    // Encontrar o índice do toten ativo diretamente do servidor
                    const activeTotenIndex = loadedTotens.findIndex(toten => toten.check === true);
                    setActiveTotenIndex(activeTotenIndex !== -1 ? activeTotenIndex : 0); // Use o primeiro toten como padrão se nenhum estiver ativo

                    // Pegar o tokenExpiry do toten ativo
                    const activeToten = loadedTotens[activeTotenIndex !== -1 ? activeTotenIndex : 0];

                    // Verificar se o tokenExpiry está no localStorage, se não estiver ou for undefined, adicioná-lo
                    const localStorageTokenExpiry = localStorage.getItem('tokenExpiry');
                    if (!localStorageTokenExpiry || localStorageTokenExpiry === 'undefined') {
                        localStorage.setItem('tokenExpiry', activeToten.tokenExpiry);
                    }

                    setHasLoadedInitialData(true);
                    setIsLoadingInitial(false);

                } else {

                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${userId}`)
                        .then(userResponse => {
                            const user = userResponse.data;
                            const userToten = {
                                toten: 'perfil1',
                                check: true,
                                perfilName: user.perfilName || user.Name,
                                perfilLastName: user.perfilLastName || user.LastName,
                                userHandle: '',
                                profilePicture: user.perfil_picture || `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`,
                                colors: { Titulos: '#ffffff', Textos: '#ffffff', Fundo: '#ffffff' } // Adiciona valores padrão para colors
                            };
                            setTotens([userToten]);
                            setTotenConfigs([{
                                titleFont: '', // Use o valor padrão se não houver configuração salva
                                textFont: ''  // Use o valor padrão se não houver configuração salva
                            }]);

                            setActiveTotenIndex(0); // O primeiro toten é ativo por padrão
                            setIsLoadingInitial(false);
                        })
                        .catch(userError => {
                            console.log('Erro ao carregar dados do usuário:', userError);
                            setIsLoadingInitial(false);
                        });
                }
            })
            .catch(profileError => {
                console.log('Erro ao carregar perfis:', profileError);
                setIsLoadingInitial(false);
            });
    }, [userId]);

    useEffect(() => {
        console.log('Totens atualizados:', totenConfigs);
        console.log('Font for first toten:', totenConfigs[0]?.titleFont);
    }, [totenConfigs]);


    const handleTotenChange = (index, field, value) => {
        // Verifica se o campo sendo atualizado é 'description' e o valor excede 1000 caracteres
        if (field === 'description' && value.length > 2000) {
            // Exibe um alerta informando que o limite de caracteres foi excedido
            Swal.fire({
                icon: 'warning',
                title: t('profile', 'characterLimitExceeded'),
                text: t('profile', 'textTooLong'),
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        } else {
            // Para os outros campos, ou se 'description' está dentro do limite, atualize normalmente
            const updatedTotens = totens.map((toten, idx) => {
                if (idx === index) {
                    if (field === 'colors') {
                        // Atualiza o objeto de cores se o campo for 'colors'
                        return { ...toten, colors: { ...toten.colors, ...value } };
                    } else {
                        // Atualiza outros campos diretamente
                        return { ...toten, [field]: value };
                    }
                }
                return toten;
            });

            setTotens(updatedTotens);
        }
    };

    const handleSummaryClick = async (index) => {
        try {
            // Encontrar o toten correspondente pelo índice
            const selectedToten = totens[index];

            console.log(selectedToten);

            let summary

            if (selectedToten.schemaPCI && selectedToten.schemaPCI.brief_pci) {
                summary = selectedToten.schemaPCI.brief_pci;
            } else {
                summary = '';
            }

            // Verifica se o resumo está vazio e exibe um placeholder apropriado
            const finalSummary = summary || t('profile', 'summaryNotAvailable');

            if (!summary) {
                // Exibir um popup com um botão que redireciona para a página do PCI
                const result = await Swal.fire({
                    title: t('profile', 'summary'),
                    text: finalSummary,
                    icon: 'info',
                    showCancelButton: false,
                    confirmButtonText: 'OK', // Botão "OK"
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });

            } else {
                // Exibir o popup com o resumo atualizado
                const { value: editedSummary } = await Swal.fire({
                    title: t('profile', 'summary'),
                    input: "textarea",
                    inputValue: finalSummary,
                    inputPlaceholder: t('profile', 'summaryPlaceholder'),
                    showCancelButton: true,
                    confirmButtonText: t('profile', 'saveSummary'),
                    cancelButtonText: t('profile', 'cancel'),
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    },
                    didOpen: () => {
                        const textarea = Swal.getPopup().querySelector('textarea');
                        if (textarea) {
                            textarea.selectionStart = 0;
                            textarea.selectionEnd = 0;
                            textarea.focus();
                            textarea.scrollTop = 0;
                        }
                    }
                });


                if (editedSummary && editedSummary !== finalSummary) {
                    // Atualizar o estado local com o resumo editado
                    const updatedTotens = totens.map((toten, idx) =>
                        idx === index ? { ...toten, schemaPCI: { ...toten.schemaPCI, brief_pci: editedSummary } } : toten
                    );

                    setTotens(updatedTotens);

                    // Salvar a alteração no banco de dados
                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl/updateSummary`, {
                        userId,
                        totenId: selectedToten.toten, // ou o identificador adequado do toten
                        summary: editedSummary
                    });

                    Swal.fire({
                        icon: 'success',
                        title: t('profile', 'summarySaved'),
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    });
                }
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: t('profile', 'errorTitle'),
                text: error.message,
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };


    const addNewToten = () => {

        if (totens.length < 3) {
            // Encontrar um identificador que ainda não está em uso
            let newTotenId = 'perfil1'; // Valor padrão
            const existingIds = totens.map(toten => toten.toten);
            if (!existingIds.includes('perfil1')) newTotenId = 'perfil1';
            else if (!existingIds.includes('perfil2')) newTotenId = 'perfil2';
            else if (!existingIds.includes('perfil3')) newTotenId = 'perfil3';

            const newToten = {
                toten: newTotenId,
                check: false,
                perfilName: '',
                perfilLastName: '',
                userHandle: '',
                profilePicture: `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`,
                colors: {
                    Titulos: '#ffffff',
                    Textos: '#ffffff',
                    Fundo: '#ffffff'
                }
            };

            setTotens([...totens, newToten]);
            setTotenConfigs([...totenConfigs, { titleFont: '', textFont: '' }]);

        }
    };


    const removeToten = async (indexToRemove) => {
        const totenToRemove = totens[indexToRemove];

        if (indexToRemove === activeTotenIndex) {
            Swal.fire({
                title: t('profile', 'actionNotAllowed'),
                text: t('profile', 'cannotDeleteActiveToten'),
                icon: 'error',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
            return;
        }

        const result = await Swal.fire({
            title: t('profile', 'areYouSure'),
            text: t('profile', 'cannotReverse'),
            icon: 'warning',
            customClass: {
                popup: 'my-swal-special',
                title: 'myCustomTitle'
            },
            showCancelButton: true,
            cancelButtonText: t('profile', 'cancel'),
            confirmButtonText: t('profile', 'yesDelete')
        });

        if (result.isConfirmed) {
            const updatedTotens = totens.filter((_, index) => index !== indexToRemove);
            setTotens(updatedTotens);

            // Enviar requisição para deletar o toten do banco de dados
            try {
                await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/users/profiles/delete`, { data: { userId, toten: totenToRemove.toten } });
                Swal.fire({
                    title: t('profile', 'deleted'),
                    text: t('profile', 'totenDeleted'),
                    icon: 'success',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });

                if (activeTotenIndex === 2) {
                    setActiveTotenIndex(1);
                    localStorage.setItem('activeTotenIndex', '1');
                }


            } catch (error) {
                console.error('Erro ao deletar perfil:', error);
                Swal.fire({
                    title: t('profile', 'errorTitle'),
                    text: t('profile', 'errorOccurred'),
                    icon: 'error',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });
            }
        }
    };


    const saveToten = async (index) => {

        setIsLoading(true);

        const toten = {
            ...totens[index],
            titleFont: totenConfigs[index].titleFont,
            textFont: totenConfigs[index].textFont
        };


        console.log('DESCOBRINDO O VALOR DE TOTEN: ');
        console.log(toten);


        if (localStorage.getItem('firstAccess') !== 'undefined' && localStorage.getItem('firstAccess') === 'true') {

            firstAccess = true;

        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/profiles/save`, {
                userId: userId,
                toten: toten,
                firstAccess: firstAccess
            });


            if (response.data.error) {
                throw new Error(response.data.message);
            }

            if (response.data) {

                if (index === activeTotenIndex) {

                    localStorage.setItem('characteristic', response.data.toten.characteristic);
                    localStorage.setItem('name', response.data.toten.perfilName);
                    localStorage.setItem('lastname', response.data.toten.perfilLastName);
                    localStorage.setItem('userHandle', response.data.toten.userHandle);
                    localStorage.setItem('perfil_picture', response.data.toten.profilePicture);
                    localStorage.setItem('colors', JSON.stringify(response.data.toten.colors));
                    localStorage.setItem('titleFont', response.data.toten.titleFont); // Salva a fonte do título
                    localStorage.setItem('textFont', response.data.toten.textFont);
                    localStorage.setItem('totenId', response.data.toten.toten);
                    localStorage.setItem('tokenExpiry', response.data.toten.tokenExpiry);
                    // localStorage.setItem('titleFontChanged', totenConfigs[index].titleFontChanged ? 'true' : 'false');
                    // localStorage.setItem('textFontChanged', totenConfigs[index].textFontChanged ? 'true' : 'false');

                }

            }

            setIsLoading(false);


            if (response.status === 200) {

                if (firstAccess && typeofPlan !== "Starter") {

                    Swal.fire({
                        title: t('profile', 'idealCustomerProfileTitle'),
                        text: t('profile', 'idealCustomerProfileText'),
                        icon: 'info',
                        confirmButtonText: t('profile', 'confirmButtonText'),
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    }).then(() => {

                        pciOpen(localStorage.getItem('language'));

                    });

                } else {

                    Swal.fire({
                        title: t('profile', 'successTitle'),
                        text: t('profile', 'profileSavedSuccess'),
                        icon: 'success',
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    });

                }

            }
        } catch (error) {

            console.error('Erro ao salvar o perfil:', error);
            let errorMessage = t('profile', 'unknownError');

            Swal.fire({
                title: t('profile', 'errorTitle'),
                text: errorMessage, //'Ocorreu um erro ao salvar o perfil.',
                icon: 'error',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });

            setIsLoading(false);
        }
    };

    const handleActivateToten = (index) => {
        const toten = totens[index];


        if (toten.perfilName && toten.perfilLastName && toten.userHandle) {


            if (!toten.tokenExpiry) {
                // Remover tokenExpiry do localStorage, caso não exista no toten ativo
                localStorage.removeItem('tokenExpiry');
            }


            const updatedTotens = totens.map((toten, idx) => {
                if (idx === index) {
                    return { ...toten, check: true }; // Ativa o toten
                } else {
                    return { ...toten, check: false }; // Desativa os outros totens
                }
            });



            setTotens(updatedTotens);
            setActiveTotenIndex(index);

            setShouldSaveTotens(true);
        } else {
            Swal.fire({
                title: t('profile', 'attentionFillAllFields'),
                text: t('profile', 'fillAllFieldsBeforeActivating'),
                icon: 'warning',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };


    useEffect(() => {
        if (shouldSaveTotens) {
            const activeToten = totens[activeTotenIndex];
            if (activeToten) {
                // Salva o toten ativo
                saveToten(activeTotenIndex);
                localStorage.setItem('activeTotenIndex', activeTotenIndex.toString());

                // Reseta a flag
                setShouldSaveTotens(false);
            }
        }
    }, [totens, shouldSaveTotens, activeTotenIndex]);

    const labels = {
        Titulos: t('profile', 'titles'), // Versão amigável com acento
        Textos: t('profile', 'texts'),
        Fundo: t('profile', 'background')
    };


    function handlePasswordChange(newValue, setTemporaryPassword) {
        if (newValue.length <= 12) {
            setTemporaryPassword(newValue);
        } else {
            Swal.fire({
                icon: 'warning',
                title: t('profile', 'characterLimitExceeded'),
                text: t('profile', 'passwordCharacterLimit'),
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    }



    const startLoginInstagram = (index) => {
        Swal.fire({
            title: t('profile', 'connectionBusinessTitle'),
            html: t('profile', 'connectionBusinessText'),
            icon: 'info',
            confirmButtonText: t('profile', 'confirmButtonBusiness'),
            customClass: {
                popup: 'my-swal-special',
                title: 'myCustomTitle'
            },
            preConfirm: () => {

                handleInstagramLogin(index);
            }
        });
    }



    const silentSaveToten = async (index) => {
        const toten = {
            ...totens[index],
            titleFont: totenConfigs[index].titleFont,
            textFont: totenConfigs[index].textFont
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/profiles/save`, {
                userId: userId,
                toten: toten,
                firstAccess: false // Força como false para não mostrar mensagens de primeiro acesso
            });

            if (response.data.error) {
                throw new Error(response.data.message);
            }

            if (response.data && response.status === 200) {
                if (index === activeTotenIndex) {
                    // Atualiza localStorage
                    localStorage.setItem('characteristic', response.data.toten.characteristic);
                    localStorage.setItem('name', response.data.toten.perfilName);
                    localStorage.setItem('lastname', response.data.toten.perfilLastName);
                    localStorage.setItem('userHandle', response.data.toten.userHandle);
                    localStorage.setItem('perfil_picture', response.data.toten.profilePicture);
                    localStorage.setItem('colors', JSON.stringify(response.data.toten.colors));
                    localStorage.setItem('titleFont', response.data.toten.titleFont);
                    localStorage.setItem('textFont', response.data.toten.textFont);
                    localStorage.setItem('totenId', response.data.toten.toten);
                    localStorage.setItem('tokenExpiry', response.data.toten.tokenExpiry);
                }
                return true;
            }
            return false;
        } catch (error) {
            console.error('Erro ao salvar o perfil silenciosamente:', error);
            return false;
        }
    };


    const handleLoginInstagram = async (index) => {
        const toten = totens[index];
        const now = new Date();

        // Verificar se o perfil foi salvo e se os campos necessários estão preenchidos
        if (!toten.perfilName || !toten.perfilLastName || !toten.userHandle) {
            Swal.fire({
                title: t('profile', 'incompleteInfoTitle'),
                text: t('profile', 'incompleteInfoText'),
                icon: 'warning',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                },
                confirmButtonText: t('profile', 'understood')
            });
            return;
        }


        const savedSuccessfully = await silentSaveToten(index);

        if (!savedSuccessfully) {
            Swal.fire({
                title: t('profile', 'errorTitle'),
                text: t('profile', 'unknownError'),
                icon: 'error',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                },
                confirmButtonText: t('profile', 'understood')
            });
            return;
        }

        // Verifica se existe uma conexão válida
        if (new Date(toten.tokenExpiry) > now) {
            Swal.fire({
                title: t('profile', 'existingConnectionTitle'),
                text: t('profile', 'existingConnectionText'),
                icon: 'question',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: t('profile', 'keepButton'),
                denyButtonText: t('profile', 'changeButton'),
                cancelButtonText: t('profile', 'deleteButton'),
                allowOutsideClick: false, // Adicionado para evitar fechar ao clicar fora
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            }).then((result) => {
                if (result.isDenied) {
                    // Prossegue para trocar a conexão
                    startLoginInstagram(index);
                } else if (result.isDismissed) {
                    // Exclui a conexão existente
                    deleteInstagramConnection(index, true);
                }
            });
        } else {
            // Não existe conexão ou ela está expirada
            startLoginInstagram(index);
        }
    };

    const deleteInstagramConnection = (index, bit) => {
        // Limpar os campos relacionados ao token
        const totenToUpdate = { ...totens[index], tokenExpiry: null };
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/delete-token`, {
            userId: userId,
            totenIndex: index,
        }).then(response => {

            if (bit) {
                Swal.fire({
                    title: t('profile', 'connectionDeletedTitle'),
                    text: t('profile', 'connectionDeletedText'),
                    icon: 'success',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });
            }

            // Atualiza o estado local após remover a conexão
            const updatedTotens = [...totens];
            updatedTotens[index] = totenToUpdate;
            setTotens(updatedTotens);
            setTotenConnections(prev => prev.map((conn, idx) => idx === index ? false : conn));


            if (index === activeTotenIndex) {

                localStorage.removeItem('tokenExpiry');

            }


        }).catch(error => {

            console.error('Erro ao excluir a conexão:', error);
            if (bit) {
                Swal.fire({
                    title: t('profile', 'errorTitle'),
                    text: t('profile', 'deleteErrorText'),
                    icon: 'error',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });
            }
        });
    };


    // Função para enviar logs do frontend para o backend
    const sendFrontendLog = async ({ message, step, userId, additionalInfo, severity = 'INFO' }) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/frontendLog`, {
                message,
                step,
                userId,
                additionalInfo,
                severity,
                source: 'frontend',
            });
        } catch (error) {
            console.error('Failed to send frontend log:', error);
        }
    };


    const handleInstagramLogin = async (totenIndex) => {
        const clientId = process.env.REACT_APP_INSTAGRAM_APP_ID;
        const redirectUri = process.env.REACT_APP_INSTAGRAM_URL_REDIRECT;
        const loginUrl = `https://www.instagram.com/oauth/authorize/?enable_fb_login=0&force_authentication=1&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=instagram_business_basic,instagram_business_content_publish`;

        try {
            await sendFrontendLog({
                message: 'Starting Instagram login process',
                step: 'start_login',
                userId,
                additionalInfo: { clientId, redirectUri, loginUrl, totenIndex },
            });

            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            const url = loginUrl + `&state=${encodeURIComponent('Instagram' + ':' + totenIndex + ':' + activeTotenIndex)}`;

            if (isMobile) {
                window.location.href = url;
                await sendFrontendLog({
                    message: 'Redirected to Instagram login on mobile',
                    step: 'redirect_mobile',
                    userId,
                    additionalInfo: { url },
                });
                return;
            }

            const width = 700;
            const height = 750;
            const left = (window.innerWidth / 2) - (width / 2);
            const top = (window.innerHeight / 2) - (height / 2);

            const newWindow = window.open(url, 'Instagram Login', `width=${width},height=${height},top=${top},left=${left}`);

            await sendFrontendLog({
                message: 'Opened Instagram login popup',
                step: 'open_login_popup',
                userId,
                additionalInfo: { url, width, height, top, left },
            });

            let n = 0;

            const interval = setInterval(async () => {
                try {
                    // Se a janela foi fechada pelo usuário
                    if (newWindow.closed) {

                        clearInterval(interval);

                        if (n === 0) {
                            await instaConnectionOk(totenIndex);
                            n++;
                        }
                    }

                } catch (error) {

                    if (error instanceof DOMException && error.name === "SecurityError") {
                        console.log("Cross-origin access blocked, but this is expected here. No log will be generated.");
                    } else if (error.message && error.message.includes('Blocked a frame with origin')) {
                        console.log("Blocked a frame with origin error detected. No log will be generated.");
                    } else {
                        console.error('Erro não esperado:', error);
                        await sendFrontendLog({
                            message: `Unexpected error occurred during interval check: ${error.message}`,
                            step: 'interval_check_error',
                            userId,
                            additionalInfo: { error: error.stack, totenIndex },
                            severity: 'ERROR',
                        });
                    }

                }
            }, 1000);

        } catch (error) {
            console.error('Erro ao iniciar processo de login do Instagram:', error);

            await sendFrontendLog({
                message: `Error during Instagram login initialization: ${error.message}`,
                step: 'login_initialization_error',
                userId,
                additionalInfo: { error: error.stack, totenIndex },
                severity: 'ERROR',
            });
        }
    };


    // Função para enviar o `code` para o backend e trocar pelo `access_token`
    const instaConnectionOk = async (totenIndex) => {

        try {

            await sendFrontendLog({
                message: 'Connection with Instagram is ok?',
                step: 'consult_connection_with_instagram',
                userId,
                additionalInfo: { totenIndex },
            });


            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/basic-instagram-info`, {
                userId: userId,
                totenId: totenIndex
            });

            const { data } = response;

            if (data && data.tokenExpiry) {

                setTotens(prevTotens => prevTotens.map((toten, idx) => {

                    if (idx === totenIndex) {
                        return {
                            ...toten,
                            tokenExpiry: data.tokenExpiry,
                            // Atualiza o userHandle com o username do Instagram
                            userHandle: data.instagramUsername ? `@${data.instagramUsername}` : toten.userHandle,
                            // Atualiza o profilePicture com a foto do Instagram
                            profilePicture: data.instagramPicture || toten.profilePicture
                        };
                    }
                    return toten;
                }));

                const instagramUsername = data.instagramUsername ? `@${data.instagramUsername}` : '';

                let connectionSuccessMessage = t('profile', 'instagramConnectionSuccess');
                connectionSuccessMessage = connectionSuccessMessage.replace('{{username}}', instagramUsername);

                await sendFrontendLog({
                    message: `Instagram account connected successfully: ${instagramUsername}`,
                    step: 'instagram_connection_success',
                    userId,
                    additionalInfo: { instagramUsername, tokenExpiry: data.tokenExpiry },
                });

                Swal.fire({
                    title: t('profile', 'successTitle'),
                    text: connectionSuccessMessage, // Texto de sucesso com o nome do usuári,
                    icon: 'success',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    },
                    confirmButtonText: t('profile', 'confirmButtonText')
                });

                setTotenConnections(prev => {
                    const updatedConnections = [...prev];
                    updatedConnections[totenIndex] = true; // Defina a conexão como verdadeira
                    return updatedConnections;
                });

                if (totenIndex === activeTotenIndex) {

                    localStorage.setItem('tokenExpiry', data.tokenExpiry);
                    localStorage.setItem('userHandle',  data.instagramUsername);
                    localStorage.setItem('perfil_picture', data.instagramPicture);

                }

            } else {

                console.error('Nenhuma conta do Instagram retornada:', data);

                await sendFrontendLog({
                    message: 'No Instagram account returned from backend',
                    step: 'no_instagram_account',
                    userId,
                    additionalInfo: { data },
                    severity: 'ERROR',
                });


                Swal.fire({
                    title: t('profile', 'errorTitle'),
                    text: t('profile', 'noInstagramAccountError'),
                    icon: 'error',
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    },
                    confirmButtonText: t('profile', 'confirmButtonText')
                });

            }
        } catch (error) {

            const errorMessage = error.response?.data?.error || t('profile', 'instagramConnectionError');
            const isInvalidAccountType = error.response?.data?.error === 'invalid_account_type';

            console.error(t('profile', 'instagramConnectionErrorLog'), error);

            await sendFrontendLog({
                message: `Error exchanging Instagram code for access token: ${error.message}`,
                step: 'exchange_code_error',
                userId,
                additionalInfo: { error: error.stack },
                severity: 'ERROR',
            });

            Swal.fire({
                title: t('profile', 'errorTitle'),
                text: isInvalidAccountType ? t('profile', 'invalidAccountTypeError') : errorMessage,
                icon: 'error',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                },
                confirmButtonText: t('profile', 'confirmButtonText')
            });
        }
    };



    const customStyles = {
        options: {
            arrowColor: '#8E59FF', // Cor do balão de dicas
            backgroundColor: '#FFFFFF', // Cor de fundo do balão de dicas
            primaryColor: '#8E59FF', // Cor primária usada para o botão de ação
            textColor: '#757575', // Cor do texto
            zIndex: 1000, // Z-index para o elemento sobrepor outros componentes
        },
        buttonNext: {
            backgroundColor: '#8E59FF' // Cor do botão "Próximo"
        },
        buttonBack: {
            backgroundColor: '#CCCCCC',
            color: '#FFFFFF' // Cor do botão "Voltar"
        },
        buttonSkip: {
            backgroundColor: '#CCCCCC',
            color: '#FFFFFF' // Cor do botão "Pular"
        }
    };

    const isValidUrl = (url) => {
        try {
            new URL(url);
        } catch (e) {
            return false;
        }
        return true;
    };

    const UserProfileImage = ({ userId, perfilPicture }) => {
        const defaultAvatarUrl = `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`;
        const imageUrl = isValidUrl(perfilPicture) ? perfilPicture : defaultAvatarUrl;
        return (
            <div className="user-profile-image" style={{ backgroundImage: `url(${imageUrl})` }}></div>
        );
    };

    // Sidebar igual ao GrowthPilot
    const renderSidebar = () => {
        if (!fromGrowthPilot) return null;
        return (
            <div className={`sidebar-fixed ${isMobile && isSidebarOpen ? 'active' : ''} ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <FaRobot size={22} />
                        <span className="menu-text">GrowthPilot</span>
                    </div>
                    <div className="sidebar-toggle-btn" onClick={() => setIsSidebarCollapsed(prev => !prev)}>
                        <MdKeyboardArrowLeft size={24} />
                    </div>
                </div>
                <div className="sidebar-menu">
                    <div className="menu-item" onClick={() => navigate(`/growthpilot?lang=${language}`)}>
                        <MdEventAvailable size={20} />
                        <span className="menu-text">Content Planner</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/pci?from=growthpilot&lang=${language}`)}>
                        <RiCopperCoinLine size={20} />
                        <span className="menu-text">PCI</span>
                    </div>
                    <div className="menu-item active">
                        <MdFace size={20} />
                        <span className="menu-text">Avatares</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/history?lang=${language}${fromGrowthPilot ? '&from=growthpilot' : ''}`)}>
                        <MdForum size={20} />
                        <span className="menu-text">Histórico de Conteúdo</span>
                    </div>
                    <div className="menu-item" onClick={() => automacaoOpen(language)}>
                        <MdAutorenew size={20} />
                        <span className="menu-text">Automação</span>
                    </div>

                    <div className="menu-item" onClick={() => navigate(`/growthpilot/analytics?lang=${language}`)}>
                        <MdDashboard size={20} />
                        <span className="menu-text">Analytics</span>
                    </div>

                    <div className="menu-item" onClick={() => navigate(`/growthpilot/config?lang=${language}`)}>
                        <MdSettings size={20} />
                        <span className="menu-text">Configurações</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/main?lang=${language}`)}>
                        <MdArrowBack size={20} />
                        <span className="menu-text">Voltar para o PostSucesso</span>
                    </div>
                    
                </div>
                <div className="sidebar-footer">
                    <div className="support-button">
                        <MdLocalActivity size={22} />
                        <span className="menu-text">Suporte</span>
                    </div>
                </div>
            </div>
        );
    };

    return (

        <>
            {renderSidebar()}
            <div className={`admin-form${fromGrowthPilot ? ' growthpilot-font' : ''}${isSidebarCollapsed ? ' sidebar-collapsed' : ''}`}>

            <Joyride
                run={runJoyride}
                steps={joyrideSteps}
                styles={customStyles}
                continuous={true}
                showSkipButton={true}
                locale={{ skip: t('profile', 'joyrideLabelsSkip'), next: t('profile', 'joyrideLabelsNext'), back: t('profile', 'joyrideLabelsBack'), last: t('profile', 'joyrideLabelsLast') }}
                callback={(data) => {
                    if (data.status === 'finished' || data.status === 'skipped') {
                        setRunJoyride(false);
                    }
                }}
            />

                <ChakraProvider>
                    <CustomDrawer
                        isOpen={isOpen}
                        onClose={handleCloseDrawer}
                        handleChange={handleChange}
                        isGPT4Enabled={isGPT4Enabled}
                        onAnalysisOpen={() => analysisOpen(language)}
                        onContentOpen={() => mainOpen(language)}
                        onPCI={() => pciOpen(language)}
                        onLogout={() => logout(language)}
                        onHistoryOpen={() => historyOpen(language)}
                        onAutomacaoOpen={() => automacaoOpen(language)}
                        t={t}
                        language={language}
                        setLanguage={setLanguage}
                    />
                </ChakraProvider>

                {fromGrowthPilot ? (
                    // Header do GrowthPilot
                    <div className="growthpilot-topbar">
                        <div className="growthpilot-title-container">
                            <div className="growthpilot-title">
                                <MdFace size={24} className="title-icon" />
                                Avatares
                            </div>
                        </div>
                        <div className="topbar-actions">
                            <div className="growthpilot-user growthpilot-user-large">
                                <UserProfileImage userId={userId} perfilPicture={localStorage.getItem('perfil_picture')} />
                            </div>
                        </div>
                    </div>
                ) : (
                    // Header original do PostSucesso
                    <>
                <div className="image-container_01" style={{ backgroundColor: '#f8f9fa', width: 50, height: 42, zIndex: 5 }}>
                    <MdMenu
                        className="menu-icon"
                        onClick={handleHamburguerClick}
                    />
                </div>
                <div className="header_form">
                    <div className="logo-container-form">
                        <img
                            src="https://blob01instasuccess.blob.core.windows.net/fotos-logos/postSucessoLogo.png"
                            alt="Logo"
                            className="logo-image-form"
                        />
                    </div>
                </div>
                    </>
                )}

                {isViewMode ? (
                    <>
                        <div className={`totens-container${fromGrowthPilot ? ' growthpilot-mode' : ''}`} style={{
                            height: typeofPlan === "Starter" ? '85%' : '100%',
                            marginTop: typeofPlan === "Starter" ? (isMobileII ? '0px' : '30px') : (isMobileII ? '35px' : '75px')
                        }}>
                            {isLoadingInitial && fromGrowthPilot ? (
                                <div className="gp-loading-center">
                                    <div className="gp-dots">
                                        <div className="gp-dot"></div>
                                        <div className="gp-dot"></div>
                                        <div className="gp-dot"></div>
                                    </div>
                                </div>
                            ) : isLoading ? (
                                <div className={`blink_2${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>{t('profile', 'savingProfile')}</div>
                            ) : (
                                <>
                                    {totens.map((toten, index) => (
                                        <form key={index} onSubmit={handleSubmit} className={`toten-form${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                            <div className={`grid-cell-4${fromGrowthPilot ? ' growthpilot-mode' : ''}`} style={{ textAlign: 'center' }}>
                                                {index !== 0 ? (
                                                    <span
                                                        style={{ cursor: 'pointer', fontSize: '10px', marginRight: '0px' }}
                                                        title="excluir"
                                                        onClick={() => removeToten(index)}>
                                                        {'❌'}
                                                    </span>
                                                ) : (
                                                    <span style={{ fontSize: '10px', marginRight: '0px', opacity: 0, cursor: 'default' }}>
                                                        {'❌'}
                                                    </span>
                                                )}
                                            </div>
                                            <div className={`avatar-container${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                <img 
                                                    src={toten.profilePicture} 
                                                    alt="User Avatar" 
                                                    title={t('profile', 'clickToUploadPhoto')} 
                                                    onClick={() => uploadImage(index)} 
                                                    className={`user-avatar${fromGrowthPilot ? ' growthpilot-mode' : ''}`} 
                                                />
                                                <MdCameraAlt className={`camera-icon${fromGrowthPilot ? ' growthpilot-mode' : ''}`} />
                                            </div>
                                            <div className="input-container-englob">
                                                <div className="input-container firstName">
                                                    <input
                                                        type="text"
                                                        value={toten.perfilName}
                                                        onChange={(e) => handleTotenChange(index, 'perfilName', e.target.value)}
                                                        placeholder={t('profile', 'profileName')}
                                                    />
                                                </div>
                                                <div className="input-container lastName">
                                                    <input
                                                        type="text"
                                                        value={toten.perfilLastName}
                                                        onChange={(e) => handleTotenChange(index, 'perfilLastName', e.target.value)}
                                                        placeholder={t('profile', 'profileLastName')}
                                                    />
                                                </div>
                                            </div>
                                            <input
                                                type="text"
                                                value={toten.userHandle}
                                                onChange={(e) => handleTotenChange(index, 'userHandle', e.target.value)}
                                                placeholder={t('profile', 'socialHandle')}
                                                className={`social${fromGrowthPilot ? ' growthpilot-mode' : ''}`}
                                            />
                                            {fromGrowthPilot ? null : (
                                            <textarea
                                                value={toten.description}
                                                onChange={(e) => handleTotenChange(index, 'description', e.target.value)}
                                                placeholder={t('profile', 'customCarouselPlaceholder')}
                                                    rows="3"
                                                    className={`textAreaFundo${fromGrowthPilot ? ' growthpilot-mode' : ''}`}
                                                style={{
                                                    borderRadius: '5px', padding: '10px'
                                                    }}
                                            />
                                            )}
                                            <div className={`buttonMeta${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                <button
                                                    style={fromGrowthPilot ? {} : { backgroundColor: '#8E59FF' }}
                                                    type="button"
                                                    className={`googleButtonUser${fromGrowthPilot ? ' growthpilot-mode instagram-connect' : ''}`}
                                                    onClick={() => handleLoginInstagram(index)}
                                                >
                                                    <FaInstagram size={25} className={`iconInsta${fromGrowthPilot ? ' growthpilot-mode' : ''}`} /> {t('profile', 'connectionNeededTitle')}
                                                </button>
                                                <div className={`statusIndicator${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                    <span className={`emoji${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>{totenConnections[index] ? '🟢' : '⚪'}</span>
                                                </div>
                                            </div>
                                            {typeofPlan !== "Starter" && !fromGrowthPilot && (
                                                <div className={`labelContainer${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                    <label className={`labelColorLink${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>{t('profile', 'ICP')} </label>
                                                    <Link className={`clnLink${fromGrowthPilot ? ' growthpilot-mode' : ''}`} onClick={() => handleSummaryClick(index)}>
                                                        <MdLink className={`iconClass${fromGrowthPilot ? ' growthpilot-mode' : ''}`} /> {t('profile', 'summ')}
                                                        </Link>
                                                    </div>
                                                )}
                                            <div className={`buttonGroupPerfil${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                {typeofPlan !== "Starter" && (
                                                    <button type="button" className={`googleButtonUser saveBtn${fromGrowthPilot ? ' growthpilot-mode' : ''}`} onClick={() => saveToten(index)}>{t('profile', 'save')}</button>
                                                )}
                                                <button type="button" className={`googleButtonUser activeBtn${fromGrowthPilot ? ' growthpilot-mode' : ''} ${activeTotenIndex === index ? "googleButtonUserActivo" : ""}`} onClick={() => handleActivateToten(index)}>
                                                    {typeofPlan === "Starter"
                                                        ? t('profile', 'save')
                                                        : (activeTotenIndex === index ? t('profile', 'active') : t('profile', 'activate'))}
                                                </button>
                                            </div>
                                        </form>
                                    ))}
                                    {typeofPlan !== "Starter" && (
                                        totens.length < 3 && (
                                            <div className={`add-toten-button-container${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                                <MdAddCircle onClick={addNewToten} color={fromGrowthPilot ? "#000" : "#8E59FF"} fontSize={50} />
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <form onSubmit={handleSubmit} className={`register-form${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                            <h2 className={`categoryTitleH2${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                {t('profile', 'register')}
                            </h2>
                            <h4 className={`categoryTitleH4${fromGrowthPilot ? ' growthpilot-mode' : ''}`}>
                                {t('profile', 'quickandeasy')}
                            </h4 >
                            <label className="input-label">
                                {t('profile', 'firstname')}:
                                <input type="text" value={name} onChange={e => setName(e.target.value)} />
                            </label>
                            <label className="input-label">
                                {t('profile', 'lastname')}:
                                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} />
                            </label>
                            <label className="input-label">
                                {t('profile', 'email')}:
                                <input type="email" value={email} onChange={e => setEmail(e.target.value)} disabled={isViewMode} />
                            </label>
                            <label className="input-label">
                                {t('profile', 'phonenumber')}:
                                <input type="tel" value={cellPhoneNumber} onChange={e => setCellPhoneNumber(e.target.value)} disabled={isViewMode} />
                            </label >

                            <label className="input-label">
                                {t('profile', 'temporarypassword')}:
                                <input type="password" className="textInput" value={temporaryPassword} onChange={e => handlePasswordChange(e.target.value, setTemporaryPassword)} />
                            </label>
                            <input style={{ backgroundColor: '#8E59FF', borderRadius: '80px' }} type="submit" value={t('profile', 'registerbutton')} />
                        </form>
                    </>
                )}
            </div>
        </>
    );
}

export default UserForm;
